export default __webpack_public_path__ + "static/media/icn-rpm-optimum.0086ba0a.svg";